import utils from '../others/utils.js';

export default ({ Vue }) => {
  Vue.prototype.$utils = utils;
};



// WEBPACK FOOTER //
// ./src/plugins/utils.js